<div id="preview-error" *ngIf="error">
    <div class="p-5 bg-light text-dark rounded">
        <p i18n>Unable to show workflow preview.</p>
        <p class="small">{{ error.message }}</p>
    </div>
</div>

<div id="preview-graph" #mermaid></div>
